import { Colors } from '@oy/uicore';
import { Spacer, Text } from '@oy/uidesktop';
import React from 'react';
import styles from './DetailList.module.css';

type DetailListProps = {
  children: React.ReactNode;
  title?: string;
};

type DetailListEntryProps = {
  content: string | number | React.ReactNode;
  contentDesc?: string | number | React.ReactNode;
  description?: string | number | React.ReactNode;
  contentColor?: Colors;
  contentDescColor?: Colors;
  descriptionColor?: Colors;
  label: string;
};

const DetailList = ({ children, title }: DetailListProps) => {
  return (
    <div className={styles.container}>
      <Spacer bottom={Spacer.Size.M}>
        {title && <Text textStyle={Text.Style.HeadingXs}>{title}</Text>}
      </Spacer>
      <div className={styles.entryContainer}>{children}</div>
    </div>
  );
};

DetailList.Entry = ({
  content,
  contentDesc,
  description,
  contentColor = Colors.BLACK100,
  contentDescColor = Colors.BLACK40,
  descriptionColor = Colors.BLACK40,
  label,
}: DetailListEntryProps) => {
  return (
    <div className={styles.detailRow}>
      <div className={styles.detailCol}>
        <Text textStyle={Text.Style.BodyMdRegular}>{label}</Text>
        {description && (
          <Text textStyle={Text.Style.BodySmRegular} color={descriptionColor}>
            {description}
          </Text>
        )}
      </div>
      <div className={styles.detailCol}>
        <Text textStyle={Text.Style.BodyMdRegular} color={contentColor}>
          <div className={styles.detailColContent}>{content}</div>
        </Text>
        {contentDesc && (
          <Text textStyle={Text.Style.BodySmRegular} color={contentDescColor}>
            {contentDesc}
          </Text>
        )}
      </div>
    </div>
  );
};

DetailList.Divider = () => <hr style={{ margin: 0 }} />;

export default DetailList;
